export const SET_AWS_TOKEN = 'SET_AWS_TOKEN';
export function setAwsToken(payload) {
  return function (dispatch) {
    dispatch({
      type: SET_AWS_TOKEN,
      payload,
    });
  };
}

export const CLEAR_AWS_TOKEN = 'CLEAR_AWS_TOKEN';
export function clearAwsToken() {
  return function (dispatch) {
    dispatch({
      type: CLEAR_AWS_TOKEN,
    });
  };
}
